<template>
  <div class="container">
    <div class="navigation-bar">
      <div class="navigation-bar-txt">
        <span><router-link to="/">首页</router-link></span>
        <span>公司介绍</span>
      </div>
    </div>
    <div class="new-list-bar">
    <div class="news-list-box">
        <div class="news-list">
          <img src="../../assets/images/zncd1.png" />
          <div class="news-discription">
            <p class="title">智能穿戴</p>
            <p class="discription">CIA提供智能可穿戴设备，包括计步器和智能项圈，作为集成畜群管理生态系统的一部分。 这些设备支持: 
            </p>
          </div>
          <ul class="ul-list">
            <li v-for="item in coreList" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item.name }}</span>
            </li>
          </ul>
          <div class="news-discription">
            <p class="discription">凭借超长的电池续航时间和稳定的数据传输，ClA可穿戴设备有助于农场持续了解牛群状况</p>
          </div>
        </div>
        <div class="news-list">
          <img src="../../assets/images/zncd2.png" />
          <div class="news-discription">
            <p class="title">二代计步器</p>
            
          </div>
          <ul class="ul-list">
            <li v-for="item in coreList" :key="item">
              <i class="li-icon"></i><span class="span-txt">{{ item.name}}</span>
            </li>
          </ul>
         
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
const coreList = ref([
  {
    name: '活动和行为监控'
  },
  {
    name: '热量检测和育种优化'
  },
  {
    name: '健康监控和早期警报'
  },
  {
    name: '在充满挑战的农场环境中可靠地收集数据'
  }
  
])
</script>
<style lang="scss" scoped>
.new-list-bar {
  width: 1280px;
  margin: 0 auto;
  padding-bottom: 60px;

  .subtitle {
    text-align: left;
  }

}
.news-list-box {
  display: flex;
  justify-content: space-between;
  gap: 20px;

  .news-list {
    flex: 1;
    display: flex;
    flex-direction: column;

    .news-discription {
      font-size: 16px;

      .title {
        padding: 20px 0px 20px 0px;
        font-size: 32px;
        text-align: left;
      }

      .discription {
        padding-top: 0px;
        text-align: left;
      }
    }

    img {
      display: block;
      width: 625px;
    }

    .ul-list {
      margin-top: 20px;
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        flex-direction: row;
        padding: 10px 0px;

        .li-icon {
          display: block;
          width: 24px;
          height: 24px;
          background: url('../../assets/images/li-icon.svg') no-repeat left 6px;
        }

        .span-txt {
          margin-left: 10px;
          flex: 1;
          display: block;
          line-height: 32px;
          font-size: 16px;
        }
      }
    }

    .foot-discription {
      font-size: 16px;
      text-align: left;

      .title {
        padding: 20px 0px 20px 0px;
        font-size: 32px;
        text-align: left;
      }
    }
  }

}
</style>